import PropTypes from "prop-types";
import Tooltip from "@shared/v2/Tooltip";
import { CircleInfoSolidV6 } from "@shared/v2/Icomoon";

const FunnelRingLabel = ({ className, title, tooltip }) => (
  <span className={`tw-text-14d tw-font-semibold tw-text-gray-50 ${className}`}>
    {title}{" "}
    {tooltip && (
      <Tooltip
        placement="right"
        innerClassName="tw-max-w-[240px] !tw-text-left"
        trigger={<CircleInfoSolidV6 />}
        content={tooltip}
      />
    )}
  </span>
);

FunnelRingLabel.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  tooltip: PropTypes.node,
};

FunnelRingLabel.defaultProps = {
  className: "",
  title: "",
  tooltip: null,
};

export default FunnelRingLabel;
